import VueRouter from 'vue-router';
import routes from './routes';
import sessionUnavailableRedirect from './sessionGuard';
import { page } from '../analytics/events';

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.afterEach((to) => {
  const { path, query, meta: { pageName, isMobileDevice } } = to;
  // FE analytics pageView event
  page(
    pageName,
    {
      path,
      pageName,
      query,
      isMobileDevice,
      title: window.document.title.replace(/[^a-z0-9\- ]/gi, ''),
      url: window.location.href,
    },
  );
});

router.beforeEach((to, from, next) => {
  const sessionRedirect = sessionUnavailableRedirect(to);
  if (sessionRedirect) {
    next(sessionRedirect);
    return;
  }

  const noIndexTag = document.querySelector('meta[name="robots"]');
  if (to.meta.noindex) {
    if (noIndexTag) {
      noIndexTag.setAttribute('content', 'noindex');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex';
      document.head.appendChild(meta);
    }
  } else if (noIndexTag) {
    noIndexTag.remove();
  }
  next();
});

export default router;
